<template>
  <div class="button-array-setting">
    <div class="list">
      <div class="title">按钮优先级</div>
      <div class="tips">优先级最高的3个可显示的按钮会平铺显示</div>
      <draggable group="btnList" v-model="btnList" :animation="100" @change="btnListChange">
        <row v-for="btn in btnList" :key="btn.value" drag-flag>
          <template v-slot:prefix>
            <svg-icon icon-class="svgo_drag"></svg-icon>
          </template>
          <svg-icon
            :icon-class="btn.icon"
            :style="'margin-left: 3px; color:' + btn.iconColor"
          ></svg-icon>
          {{ btn.label }}
        </row>
      </draggable>
    </div>
  </div>
</template>

<script>
import Row from "@/components/BaseComponents/Panel/Row"
import draggable from "vuedraggable"

export default {
  name: "button-array-setting",
  components: {
    draggable,
    Row
  },
  props: {
    btnArray: Array
  },
  data() {
    return {
      btnList: []
    }
  },
  methods: {
    init() {
      this.btnList = this.btnArray
    },
    btnListChange() {
      this.$emit("update", {
        dataType: "btnArray",
        data: this.btnList
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-array-setting {
  margin-top: 14px;
  .list {
    margin-bottom: 14px;
    .title {
      font-size: 15px;
      font-weight: bold;
    }
    .tips {
      margin-top: 2px;
      margin-bottom: 8px;
      height: 40px;
      line-height: 40px;
      color: #757575;
      font-size: 13px;
    }
  }
}
</style>
